export default {
    searchDoctor: state => {
        return state.searchDoctor;
    },
    searchCashier: state => {
        return state.searchCashier;
    },
    searchReturn: state => {
        return state.searchReturn;
    },
    searchUnit: state => {
        return state.searchUnit;
    },
    doctors: state => {
        return state.doctors;
    },
    cashiers: state => {
        return state.cashiers;
    },
    insurances: state => {
        return state.insurances;
    },
    searchedDrs: state => {
        return state.searchedDrs;
    },
    doctorReportRows: state => {
        return state.doctorReportRows;
    },
    unitReportRows: state => {
        return state.unitReportRows;
    },
    cashierReportRows: state => {
        return state.cashierReportRows;
    },
    cashierReportRowsPrint: state => {
        return state.cashierReportRowsPrint;
    },
    returnReportRows: state => {
        return state.returnReportRows;
    },
    returnReportRowsPrint: state => {
        return state.returnReportRowsPrint;
    },
    returnTotal: state => {
        return state.returnTotal;
    },
    cashierTotal: state => {
        return state.cashierTotal;
    },
    unitTotal: state => {
        return state.unitTotal;
    },
    countOfReferrals: state => {
        return state.countOfReferrals;
    },
    referralWays: state => {
        return state.referralWays;
    },
   
}
